import './App.css';
import Dropdown from './Dropdown';
import {getSelectedSem} from "./calculations"
import Header from "./Header";
import { getBacklogStatus } from './calculations';

function App() {

  // getBacklogStatus();
  getSelectedSem();
  return (
    
    <div>
      <Header/>
    <div className="dropdown-cont">
      <Dropdown/>
    </div>
    </div>
  );
}

export default App;
